import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {ProfileService} from '../profile.service';

@Component({
    selector: 'profile-change-language',
    template: require('./profile-change-language.component.html'),
    providers: [ProfileService]
})

export class SuperUserProfileChangeLanguageComponent implements OnInit {
                
    @Input('language') userLanguage: string;
    @Output('languageUpdated') languageUpdated = new EventEmitter();    
    
    constructor(private _profileService: ProfileService) {
        
    }

    ngOnInit() {
        
    }        

   changeLanguage(lang: number) {              
       this.languageUpdated.emit({
             value: lang
        });
   }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/profile/profile_change_language/profile-change-language.component.ts
 **/